import React, { useContext, useMemo } from "react";
import { CreateTaskPopup } from "./components/createTaskPopup/CreateTaskPopup";
import { FolderList } from "./components/folderList/FolderList";
import { SessionList } from "./components/sessionList/SessionList";
import { Statistics } from "./components/statistics/Statistics";
import { TaskList } from "./components/taskList/TaskList";
import { NotesWidget } from "./components/notesWidget/NotesWidget";
import { DashboardContext } from "./DashboardContext";
import { CalendarGrid } from "../../components/calendarGrid/CalendarGrid";
import { DialogueTree } from "./components/dialogueTree/DialogueTree";
import { FullSessions } from "./components/sessions/FullSessions";
import { Lifeline } from "./components/lifeline/Lifeline";
import { Notes } from "./components/notes/Notes";
import { StatisticPage } from "./components/statisticPage/StatisticPage";
import { setTimezoneAwareHours } from "../../utils/dateFormats";

export const DashboardMain = ()=>{
    const dashboardContext = useContext(DashboardContext);
    const {
        selectedTaskIndex, setSelectedTaskIndex,
        selectedSessionIndex, setSelectedSessionIndex,
        selectedFolderIndex, setSelectedFolderIndex,
        selectedLeftMenuTabIndex, setSelectedLeftMenuTabIndex,
        activeTag, setActiveTag,
        isDashWrap, setDashWrap,
        isLeftCollapsed, setLeftCollapsed,
        showMenu, setShowMenu,
        selectedClient,
        activePopup, setActivePopup,
        setTaskList,
                bottomSelected,
                setBottomSelected,
        isDashboardVisible
    } = dashboardContext;

    //const contextData = useContext(AppContext);

    const currentClientSessions = selectedClient?.sessions || [];

    const bottomTabContent = useMemo(()=>{
        console.log('DashboardMain bottomSelected:', bottomSelected, 'selectedClient:', selectedClient?.id);
        if (bottomSelected == 'sessions') {
            return <FullSessions key={`sessions-${Date.now()}`}></FullSessions>
        }
        if (bottomSelected == 'calendar') {
            return <CalendarGrid
                key={`calendar-${Date.now()}`}
                tickets={currentClientSessions.map(session => {
                    const startDate = new Date(session.date);
                    let endDate = new Date(session.dateTo);
                    if (!session.dateTo || Number.isNaN(endDate.valueOf())) {
                        const startDateObj = new Date(session.date);
                        const endHour = new Date(startDateObj).getHours() + 1;
                        endDate = setTimezoneAwareHours(startDateObj, endHour); //default one hour if not end date
                    }
                    return {
                        start: startDate,
                        end: endDate,
                        title: session.title,
                        type: 'session',
                        original: session
                    }
                })}
            ></CalendarGrid>
        }
        if (bottomSelected == 'analysis') {
            return <DialogueTree key={`analysis-${Date.now()}`} onClose={() => setBottomSelected('sessions')} />
        }
        if (bottomSelected == 'lifeline') {
            return <Lifeline key={`lifeline-${Date.now()}`} onClose={() => setBottomSelected('sessions')} />
        }
        if (bottomSelected == 'notes') {
            console.log('Rendering Notes component');
            return <Notes key={`notes-${Date.now()}`} />
        }
        if (bottomSelected == 'statistic') {
            return <StatisticPage key={`statistic-${Date.now()}`} />
        }
        console.log('No match, returning null');
        return null;
    }, [bottomSelected, currentClientSessions, setBottomSelected]);

    return (
        <div className="scroll dashboard_main">
            <div className="dashboard_main_columns">
                <div className={`popup_layer ${['CreateTask'].includes(activePopup) ? '' : 'popup_layer--hidden'}`}>
                {activePopup == 'CreateTask' && <CreateTaskPopup 
                    onClose={()=>setActivePopup('')} 
                    onSave={(text)=>{
                        setActivePopup(''); 
                        setTaskList((last)=>[...last, {text, title: text.slice(1, 10), checked: false, label: 'tips'}])
                    }} 
                    onSaveDraft={()=>{}}
                ></CreateTaskPopup>}
                </div>
                {bottomTabContent}
            </div>
        </div>
    )
}